import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { ISiteDetailsModel } from '@apps-common/types/portal/site-details'

const createSiteDetails = async (model: ISiteDetailsModel, image: any): Promise<ISiteDetailsModel> =>
  new Promise((resolve, reject) => {
    axios
      .post(`/my-monitoring/sites/AddSiteDetails`, model)
      .then((res) => {
        if (image) {
          const fileData = new FormData()

          fileData.append('file', image?.blob || image)
          axios
            .post(`/my-monitoring/sites/UploadSiteImg?unitId=${res?.data?.data.unitId}&siteId=${res?.data?.data?.siteDetailsId}`, fileData)
            .then((imageRes) => resolve(imageRes?.data?.data))
            .catch((err) => reject(err))
        } else {
          resolve(res?.data?.data)
        }
      })
      .catch((err) => reject(err))
  })

type Props = {
  model: ISiteDetailsModel
  image: File | null | undefined
}

export const useMyMonitoringCreateSiteDetails = (notify?: boolean, onSuccess?: (data: ISiteDetailsModel) => void) =>
  useMutation({
    mutationKey: ['createMyMonitoringSiteDetails'],
    mutationFn: ({ model, image }: Props) => createSiteDetails(model, image),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created site details.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to create site details, please try again.')
      }
    },
    throwOnError: false
  })
